module.exports = __webpack_public_path__ + "media/images/back_button-276f3ded70725e5911ed47cb9e62fbf2.jpeg";